<template>
  <div>
    <!-- Input -->
    <div class="wider-box-wrapper mb-4">
      <b-card border-variant="secondary" class="border-2">
        <b-row class="mb-3 align-items-center">
          <b-col>
            Assignment Rate Per Day
            <b-icon
              icon="question"
              variant="primary"
              v-b-tooltip.hover
              title="Inclusive of holiday pay"
            ></b-icon>
          </b-col>
          <b-col cols="5" md="3" class="text-right">£ {{ results.assignmentRatePerDay.value }}</b-col>
        </b-row>
        <b-row class="mb-3 align-items-center">
          <b-col>
            Days Worked
            <b-icon
              icon="question"
              variant="primary"
              v-b-tooltip.hover
              title="Based on a full working year"
            ></b-icon>
          </b-col>
          <b-col cols="5" md="3" class="text-right">{{ results.daysWorked.value }}</b-col>
        </b-row>
      </b-card>
      <div @click="$emit('resetEdit')" class="text-right edit-text-link">Edit</div>
    </div>

    <!-- Output -->
    <div class="output-values">
      <!-- Group 1 -->
      <b-row class="mb-3 align-items-center">
        <b-col cols="7" md="9">
          Contract Value
          <abbr v-b-tooltip.hover title="Temporary Worker Service">(TWS)</abbr> per Day
        </b-col>
        <b-col
          cols="5"
          md="3"
          class="text-right"
        >£ {{ results.contractValueUmbrellaCompanyPerDay.value }}</b-col>
      </b-row>
      <b-row class="mb-3 align-items-center">
        <b-col cols="7" md="9">
          Contract Value
          <abbr v-b-tooltip.hover title="Temporary Worker Service">(TWS)</abbr>
        </b-col>
        <b-col
          cols="5"
          md="3"
          class="text-right"
        >£ {{ results.contractValueUmbrellaCompanyCharge.value }}</b-col>
        <b-icon-document-spreadsheet v-b-toggle.collapse-1></b-icon-document-spreadsheet>
      </b-row>
      <b-collapse id="collapse-1" v-model="collapseMap[1]">
        <b-card>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">
              Contract Value
              <abbr v-b-tooltip.hover title="Temporary Worker Service">(TWS)</abbr> per Day
            </b-col>
            <b-col
              cols="5"
              md="3"
              class="text-right"
            >£ {{ results.contractValueUmbrellaCompanyPerDay.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">Days Worked</b-col>
            <b-col cols="5" md="3" class="text-right">{{ results.daysWorked.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">
              Contract Value
              <abbr v-b-tooltip.hover title="Temporary Worker Service">(TWS)</abbr>
            </b-col>
            <b-col
              cols="5"
              md="3"
              class="text-right"
            >£ {{ results.contractValueUmbrellaCompanyCharge.value }}</b-col>
          </b-row>
        </b-card>
      </b-collapse>
      <!-- Group 2 -->
      <b-row class="mb-3 align-items-center">
        <b-col cols="7" md="9">
          <abbr v-b-tooltip.hover title="Temporary Worker Service">TWS</abbr>/Payroll Provider Fee
        </b-col>
        <b-col class="text-danger text-right">- £ 900.00</b-col>
      </b-row>
      <b-row class="mb-3 align-items-center">
        <b-col cols="7" md="9">Employer NI Due</b-col>
        <b-col class="text-danger text-right">-£ {{ results.employerNationalInsuranceDue.value }}</b-col>
        <b-icon-document-spreadsheet v-b-toggle.collapse-2></b-icon-document-spreadsheet>
      </b-row>
      <b-collapse id="collapse-2" v-model="collapseMap[2]">
        <b-card>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">Assignment Rate/Gross Pay Rate</b-col>
            <b-col cols="5" md="3" class="text-right">£ {{ results.grossPayRate.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">
              Assignment Rate up to and Including
              <abbr
                v-b-tooltip.hover
                title="Secondary Threshold"
              >ST</abbr>
            </b-col>
            <b-col
              cols="5"
              md="3"
              class="text-right"
            >£ {{ results.contractValueUmbrellaToSecondaryThreshold.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">
              Employer NI Due up to
              <abbr v-b-tooltip.hover title="Secondary Threshold">ST</abbr>
            </b-col>
            <b-col
              class="text-danger text-right"
            >-£ {{ results.employerNiDueToSecondaryThreshold.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">
              Assignment Rate above
              <abbr v-b-tooltip.hover title="Secondary Threshold">ST</abbr>
            </b-col>
            <b-col
              cols="5"
              md="3"
              class="text-right"
            >£ {{ results.contractValueUmbrellaAboveSecondaryThreshold.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">
              Employer NI Due above
              <abbr v-b-tooltip.hover title="Secondary Threshold">ST</abbr>
            </b-col>
            <b-col
              class="text-danger text-right"
            >-£ {{ results.employerNiDueAboveSecondaryThreshold.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">Total Employer NI Due</b-col>
            <b-col
              class="text-danger text-right"
            >-£ {{ results.employerNationalInsuranceDue.value }}</b-col>
          </b-row>
        </b-card>
      </b-collapse>
      <!-- Group 3 -->
      <b-row class="mb-3 align-items-center">
        <b-col cols="7" md="9">Assignment Rate/Gross Pay Rate</b-col>
        <b-col cols="5" md="3" class="text-right">£ {{ results.grossPayRate.value }}</b-col>
        <b-icon-document-spreadsheet v-b-toggle.collapse-3></b-icon-document-spreadsheet>
      </b-row>
      <b-collapse id="collapse-3" v-model="collapseMap[3]">
        <b-card>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">
              Assignment Rate per Day
              <b-icon
                icon="question"
                variant="primary"
                v-b-tooltip.hover
                title="Inclusive of holiday pay"
              ></b-icon>
            </b-col>
            <b-col cols="5" md="3" class="text-right">£ {{ results.assignmentRatePerDay.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">Days Worked</b-col>
            <b-col cols="5" md="3" class="text-right">{{ results.daysWorked.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">Assignment Rate/Gross Pay Rate</b-col>
            <b-col cols="5" md="3" class="text-right">£ {{ results.grossPayRate.value }}</b-col>
          </b-row>
        </b-card>
      </b-collapse>
      <!-- Group 4 -->
      <b-row class="mb-3 align-items-center">
        <b-col cols="7" md="9">Employee NI Due</b-col>
        <b-col class="text-danger text-right">-£ {{ results.totalEmployeeNiDue.value }}</b-col>
        <b-icon-document-spreadsheet v-b-toggle.collapse-4></b-icon-document-spreadsheet>
      </b-row>
      <b-collapse id="collapse-4" v-model="collapseMap[4]">
        <b-card>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">Assignment Rate/Gross Pay Rate</b-col>
            <b-col cols="5" md="3" class="text-right">£ {{ results.grossPayRate.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">
              Assignment Rate/Gross Pay Rate at or above
              <abbr
                v-b-tooltip.hover
                title="Lower Earnings Limit"
              >LEL</abbr> up to and Including
              <abbr v-b-tooltip.hover title="Primary Threshold">PT</abbr>
            </b-col>
            <b-col
              cols="5"
              md="3"
              class="text-right"
            >£ {{ results.grossPayRateAboveLowerEarningsLimitToPrimaryThreshold.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">
              Employee NI Due up to
              <abbr v-b-tooltip.hover title="Primary Threshold">PT</abbr>
            </b-col>
            <b-col
              class="text-danger text-right"
            >-£ {{ results.employeeNiDueUpToPrimaryThreshold.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">
              Assignment Rate/Gross Pay Rate above the
              <abbr
                v-b-tooltip.hover
                title="Primary Threshold"
              >PT</abbr> up to and Including
              <abbr v-b-tooltip.hover title="Upper Earnings Limit">UEL</abbr>
            </b-col>
            <b-col
              cols="5"
              md="3"
              class="text-right"
            >£ {{ results.grossPayRateAbovePrimaryThresholdToUpperEarningLimit.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">
              Employee NI Due above the
              <abbr v-b-tooltip.hover title="Primary Threshold">PT</abbr> up to and Including
              <abbr v-b-tooltip.hover title="Upper Earnings Limit">UEL</abbr>
            </b-col>
            <b-col
              class="text-danger text-right"
            >-£ {{ results.employeeNiDueAbovePrimaryThresholdToUpperEarningLimit.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">
              Assignment Rate/Gross Pay Rate above
              <abbr
                v-b-tooltip.hover
                title="Upper Earnings Limit"
              >UEL</abbr>
            </b-col>
            <b-col
              cols="5"
              md="3"
              class="text-right"
            >£ {{ results.grossPayRateAboveUpperEarningLimit.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">
              Employee NI Due above
              <abbr v-b-tooltip.hover title="Upper Earnings Limit">UEL</abbr>
            </b-col>
            <b-col
              class="text-danger text-right"
            >-£ {{ results.employeeNiDueAboveUpperEarningLimit.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">Total Employee NI Due</b-col>
            <b-col class="text-danger text-right">-£ {{ results.totalEmployeeNiDue.value }}</b-col>
          </b-row>
        </b-card>
      </b-collapse>
      <!-- Group 5 -->
      <b-row class="mb-3 align-items-center">
        <b-col cols="7" md="9">Employee PAYE Income Tax Due</b-col>
        <b-col class="text-danger text-right">-£ {{ results.totalPayeIncomeTaxDue.value }}</b-col>
        <b-icon-document-spreadsheet v-b-toggle.collapse-5></b-icon-document-spreadsheet>
      </b-row>
      <b-collapse id="collapse-5" v-model="collapseMap[5]">
        <b-card>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">Assignment Rate/Gross Pay Rate</b-col>
            <b-col cols="5" md="3" class="text-right">£ {{ results.grossPayRate.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col
              cols="7"
              md="9"
            >Personal Allowance to Include Adjustment for Assignment Rate/Gross Pay Rate > £100,000</b-col>
            <b-col
              cols="5"
              md="3"
              class="text-right"
            >£ {{ results.personalAllowanceWithAdjustment.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">Assignment Rate/Gross Pay Rate Liable to PAYE Income Tax}</b-col>
            <b-col
              cols="5"
              md="3"
              class="text-right"
            >£ {{ results.grossPayRateLiableToPayeIncomeTax.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">
              Assignment Rate/Gross Pay Rate Taxable at
              <abbr
                v-b-tooltip.hover
                title="Basic Rate Tax"
              >BRT</abbr>
            </b-col>
            <b-col
              cols="5"
              md="3"
              class="text-right"
            >£ {{ results.grossPayRateTaxableAtBasicRate.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">
              PAYE Income Tax Due at
              <abbr v-b-tooltip.hover title="Basic Rate Tax">BRT</abbr>
            </b-col>
            <b-col class="text-danger text-right">-£ {{ results.payeIncomeTaxDueAtBasicRate.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">
              Assignment Rate/Gross Pay Rate Taxable at
              <abbr
                v-b-tooltip.hover
                title="Higher Rate Tax"
              >HRT</abbr>
            </b-col>
            <b-col
              cols="5"
              md="3"
              class="text-right"
            >£ {{ results.grossPayRateTaxableAtHigherRate.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">
              PAYE Income Tax Due at
              <abbr v-b-tooltip.hover title="Higher Rate Tax">HRT</abbr>
            </b-col>
            <b-col
              class="text-danger text-right"
            >-£ {{ results.payeIncomeTaxDueAtHigherRate.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">
              Assignment Rate/Gross Pay Rate Taxable at
              <abbr
                v-b-tooltip.hover
                title="Additional Rate Tax"
              >ART</abbr>
            </b-col>
            <b-col
              cols="5"
              md="3"
              class="text-right"
            >£ {{ results.grossPayRateTaxableAtAdditionalRate.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">
              PAYE Income Tax Due at
              <abbr v-b-tooltip.hover title="Additional Rate Tax">ART</abbr>
            </b-col>
            <b-col
              class="text-danger text-right"
            >-£ {{ results.payeIncomeTaxDueAtAdditionalRate.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">Total PAYE Income Tax Due</b-col>
            <b-col class="text-danger text-right">-£ {{ results.totalPayeIncomeTaxDue.value }}</b-col>
          </b-row>
        </b-card>
      </b-collapse>
      <!-- Group 6 -->
      <b-row class="mb-3 align-items-center">
        <b-col cols="7" md="9">Net Salary</b-col>
        <b-col cols="5" md="3" class="text-right">£ {{ results.employeeNetSalary.value }}</b-col>
        <b-icon-document-spreadsheet v-b-toggle.collapse-6></b-icon-document-spreadsheet>
      </b-row>
      <b-collapse id="collapse-6" v-model="collapseMap[6]">
        <b-card>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">Assignment Rate/Gross Pay Rate</b-col>
            <b-col cols="5" md="3" class="text-right">£ {{ results.grossPayRate.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">Employee NI Due</b-col>
            <b-col class="text-danger text-right">-£ {{ results.totalEmployeeNiDue.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">Total PAYE Income Tax Due</b-col>
            <b-col class="text-danger text-right">-£ {{ results.totalPayeIncomeTaxDue.value }}</b-col>
          </b-row>
          <b-row class="mb-3 align-items-center">
            <b-col cols="7" md="9">Employee Net Salary</b-col>
            <b-col cols="5" md="3" class="text-right">£ {{ results.employeeNetSalary.value }}</b-col>
          </b-row>
        </b-card>
      </b-collapse>
    </div>

    <!-- Summary -->
    <div class="wider-box-wrapper summary-box">
      <b-card border-variant="primary" class="border-2">
        <!-- Group 7 -->
        <b-row class="mb-3 align-items-center">
          <b-col>Effective Daily Net</b-col>
          <b-col cols="5" md="3" class="text-right">£ {{ results.effectiveDailyNet.value }}</b-col>
          <b-icon-document-spreadsheet v-b-toggle.collapse-7></b-icon-document-spreadsheet>
        </b-row>
        <b-collapse id="collapse-7" v-model="collapseMap[7]">
          <b-card>
            <b-row class="mb-3 align-items-center">
              <b-col>Net Salary</b-col>
              <b-col cols="5" md="3" class="text-right">£ {{ results.employeeNetSalary.value }}</b-col>
            </b-row>
            <b-row class="mb-3 align-items-center">
              <b-col>Days Worked</b-col>
              <b-col cols="5" md="3" class="text-right">{{ results.daysWorked.value }}</b-col>
            </b-row>
            <b-row class="mb-3 align-items-center">
              <b-col>Effective Daily Net</b-col>
              <b-col cols="5" md="3" class="text-right">£ {{ results.effectiveDailyNet.value }}</b-col>
            </b-row>
          </b-card>
        </b-collapse>
        <!-- Group 8 -->
        <b-row class="mb-3 align-items-center">
          <b-col>Net Retention %</b-col>
          <b-col cols="5" md="3" class="text-right">{{ results.netRetentionPercentage.value }} %</b-col>
          <b-icon-document-spreadsheet v-b-toggle.collapse-8></b-icon-document-spreadsheet>
        </b-row>
        <b-collapse id="collapse-8" v-model="collapseMap[8]">
          <b-card>
            <b-row class="mb-3 align-items-center">
              <b-col>Net Salary</b-col>
              <b-col cols="5" md="3" class="text-right">£ {{ results.employeeNetSalary.value }}</b-col>
            </b-row>
            <b-row class="mb-3 align-items-center">
              <b-col>Assignment Rate</b-col>
              <b-col cols="5" md="3" class="text-right">£ {{ results.grossPayRate.value }}</b-col>
            </b-row>
            <b-row class="mb-3 align-items-center">
              <b-col>Net Retention %</b-col>
              <b-col cols="5" md="3" class="text-right">{{ results.netRetentionPercentage.value }} %</b-col>
            </b-row>
          </b-card>
        </b-collapse>
      </b-card>
    </div>

    <div class>
      <b-form>
        <b-button @click="nextStep" variant="primary">Go to Step 2</b-button>
      </b-form>
    </div>
  </div>
</template>

<script>
export default {
  props: ["results"],
  data() {
    return {
      collapseMap: {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false
      }
    };
  },
  computed: {
    expandAll() {
      return this.$store.state.expandCollapse.one;
    }
  },
  watch: {
    expandAll(event) {
      if (event.active) {
        if (event.value) {
          this.expand();
        } else {
          this.collapse();
        }
        this.$store.commit("expandCollapseAll", {
          calculator: "one",
          action: "reset"
        });
      }
    }
  },
  methods: {
    expand: function() {
      Object.keys(this.collapseMap).forEach(key => {
        this.collapseMap[key] = true;
      });
    },
    collapse: function() {
      Object.keys(this.collapseMap).forEach(key => {
        this.collapseMap[key] = false;
      });
    },
    nextStep: function() {
      this.$store.commit("prepopulateField", {
        calculator: "two",
        value: this.results.assignmentRatePerDay.value
      });
      this.$emit("incrementTab");
    }
  }
};
</script>
